module.exports = __webpack_public_path__ + "static/media/percentage.8123b139.svg";